import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    table {
      width: 100%;
      border: 1px solid ${theme.colors.xxlightGray};

      tr {
        cursor: pointer;

        :last-child {
          td {
            border-bottom: 0;
          }
        }
      }

      th {
        padding: 10px 20px;
        text-align: start;
        color: ${theme.colors.blue};
        font-family: ${theme.font.montserrat};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.normal};
        cursor: auto;
      }

      td {
        color: ${theme.colors.darkGray};
        font-family: ${theme.font.montserrat};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.normal};

        .table-icons {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          .delete-button svg {
            border-color: ${theme.colors.red};
          }
          button {
            background: transparent;
          }

          svg {
            height: 25px;
            width: 30px;
            border: 1px solid ${theme.colors.primary};
            border-radius: 8px;
            padding: 2px;
            cursor: pointer;
          }
        }
      }

      th,
      td {
        margin: 0;
        padding: 0.5rem;
        border-bottom: 1px solid ${theme.colors.xxlightGray};
        border-right: 1px solid ${theme.colors.xxlightGray};

        :last-child {
          border-right: 0;
        }
      }
    }

    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    ul {
      list-style: none;
      padding: 0;
    }

    ul.pagination li {
      display: inline-block;
      width: 30px;
      border: 1px solid #e2e2e2;
      display: flex;
      justify-content: center;
      font-size: 25px;
      cursor: pointer;
    }

    ul.pagination li a {
      text-decoration: none;
      color: ${theme.colors.blue};
      font-size: 20px;
    }

    ul.pagination li.active a {
      color: white;
    }
    ul.pagination li.active {
      background-color: ${theme.colors.blue};
    }

    ul.pagination li a:hover,
    ul.pagination li a.active {
      filter: brightness(0.8);
    }

    .page-selection {
      width: 48px;
      height: 30px;
      color: ${theme.colors.blue};
    }

    .pagination-wrapper {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }

    ${media.lessThan('medium')`
      overflow-x: scroll;

      ::-webkit-scrollbar {
        width: 8px;
      }

      ::-webkit-scrollbar-thumb {
        background: ${theme.colors.primary};
        border-radius: 10px;
      }
    `}
  `}
`
